<template>
  <div>
    <div class="font-size__medium font-weight__bold margin-top-15">{{ title }}</div>
    <el-input
      class="margin-top-10"
      prefix-icon="el-icon-search"
      size="medium"
      placeholder="Tìm kiếm theo tên/emai/đơn vị/chức vụ"
      @input="searchTree"
      v-model="filter.query"
    />
    <VuePerfectScrollbar class="scroll-area scroll-area-height_90 width__100">
    <el-tree
      v-loading="isLoadingRoots"
      ref="tree"
      :data="roots"
      class="filter-tree"
      node-key="id"
      show-checkbox
      check-strictly
      :default-expanded-keys="defaultExpandKeys"
      :filter-node-method="filterNode"
      @check-change="handleCheckChange"
    >
      <div
        class="custom-tree-node flex-row flex__between width__100"
        slot-scope="{ node, data }"
      >
        <div class="field-1 flex-row flex__between width__100">
          <span>
            <span v-if="data.nodeType === DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE">
              <span class="font-weight__bold">{{ data.userDeptRole.fullName }}</span>
              <span class="font-size__small font-italic">({{ data.userDeptRole.positionName }})</span>
              <span style="position: relative">
                <el-tooltip
                  v-if="data.userDeptRole.absentCount && data.userDeptRole.absentCount != 0"
                  :content="tooltipContent(data.userDeptRole)"
                  placement="right"
                  effect="dark"
                >
                  <absent-notify></absent-notify>
                </el-tooltip>
              </span>
            </span>
            <span v-else>&nbsp;{{ getNodeLabel(data) }}</span>
          </span>
          <span
            class="padding-left-right-10"
            v-if="isShowProcessTypeRadio(node)"
          >
            <el-radio-group v-model="processTypeRadio[data.userDeptRole ? data.userDeptRole.id : data.department.id]" @change="changeProcessType">
              <el-radio :label="PROCESS_TYPE_CHU_TRI">Chủ trì</el-radio>
              <el-radio :label="PROCESS_TYPE_PHOI_HOP">Phối hợp</el-radio>
              <el-radio :label="PROCESS_TYPE_NHAN_DE_BIET">Nhận để biết</el-radio>
            </el-radio-group>
          </span>
        </div>
      </div>
    </el-tree>
  </VuePerfectScrollbar>
  </div>
</template>
<script>
import handlersTreeMixin from "../../../mixins/handlersTreeMixin";
import constants from "../../../constants";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import utils from "../../../services/utils";
import h from "../../../services/h";
import dateFormatter from "../../../filters/dateFormatter";

export default {
  name: 'so-duyet-tree',
  components: {
    VuePerfectScrollbar
  },
  mixins: [handlersTreeMixin],
  props: ['title', 'userDeptRoles'],

  data() {
    return {
      DEPARTMENT_TREE: constants.DEPARTMENT_TREE,
      PROCESS_TYPE_CHU_TRI : constants.PROCESS_TYPE.CHUTRI,
      PROCESS_TYPE_PHOI_HOP : constants.PROCESS_TYPE.PHOIHOP,
      PROCESS_TYPE_NHAN_DE_BIET : constants.PROCESS_TYPE.NHANDEBIET,

      isLoadingRoots: true,
      processTypeRadio: {},
      selectedHandlersData: [],
      defaultExpandKeys: [],
      hashtagProcessTypeSelect: null,
      filter: {
        query: null,
        showChecked: false
      },
    }
  },

  created() {
    this.init();
  },

  methods: {
    async init() {
      await this.initData();
      this.buildTree();
    },

    async initData() {
      this.userDeptRoleHandlers = this.userDeptRoles;
    },

    buildTree() {
      this.buildNodes().then(() => {
        // Bỏ node ROOT
        this.roots = this.removeNodeROOT(this.roots);
        // chuyen userDeptRole trong TCT xuong cuoi tree
        this.roots = this.moveUserOfTCTToBottom(this.roots);

        this.defaultExpandKeys.push(this.roots[0].id); // Expand root node
        this.defaultExpandKeys.push(constants.DEPARTMENT_TREE.NODE_TYPE.BTGD); // Expand root node
        this.defaultExpandKeys.push(constants.DEPARTMENT_TREE.NODE_TYPE.PBCN); // Expand root node
        this.defaultExpandKeys.push(constants.DEPARTMENT_TREE.NODE_TYPE.DVTT); // Expand root node

        this.isLoadingRoots = false;
      })
    },

    filterNode(value, data, node) {
      if (!value.query && !value.showChecked) {
        return true;
      }

      let b = true;
      if (value.query) {
        switch (data.nodeType) {
          case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
            b = utils.like(data.department.deptName, value.query);
            break;
          case constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE:
            const nodeLabel = `${data.userDeptRole.fullName} (${data.userDeptRole.positionName})`;
            const nodeDeptName = data.userDeptRole.deptName;
            b = utils.like(nodeLabel + nodeDeptName, value.query);
            break;
          default:
            b = utils.like(utils.getNodeLabelForHandlersTree(data), value.query);
            break;
        }
      }

      if (value.showChecked) {
        b = b && node.checked === value.showChecked
      }

      return b;
    },

    tooltipContent(item){
      return `Vắng mặt từ `+ dateFormatter(item.absentStartTime)+` đến `+ dateFormatter(item.absentDeadlineTime);
    },

    searchTree() {
      setTimeout(() => {
        this.$refs.tree.filter(this.filter);
        if (!this.filter.query && !this.filter.showChecked) {
          this.refreshNodeExpand();
        }
      }, 200)
    },

    handleCheckChange(data, isChecked) {
      if (!isChecked) {
        this.searchTree();
      }

      const node = this.$refs.tree.getNode(data);
      if (this.isBTGDAndHDTV(data) || this.isPBCNAndDVTT(data)) {
        this.setCheckedForChildren(data, isChecked); // set checked cho children
        if (isChecked) {
          node.expanded = isChecked;
        }
      }

      this.$set(data, 'checked', isChecked);

      if (!this.isBTGDAndHDTV(data)) {
        this.setCheckedForParent(data);
        if (!this.isPBCNAndDVTT(data)) {
          let key = data.userDeptRole ? data.userDeptRole.id : data.department.id;
          if (!(key in this.processTypeRadio)) {
            let processType = this.hashtagProcessTypeSelect !== null ? this.hashtagProcessTypeSelect : constants.PROCESS_TYPE.CHUTRI;
            this.$set(this.processTypeRadio, key, processType);
          }
        }
        if (data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT || data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE) {
          this.addOrRemoveToSelectedHandlers(
            data,
            this.hashtagProcessTypeSelect !== null ? this.hashtagProcessTypeSelect : constants.PROCESS_TYPE.CHUTRI
          );
        }
      }
    },

    setCheckedForParent(data) {
      if (!('parent' in data))  {
        return;
      }
      const parentNode = this.$refs.tree.getNode(data.parent.id);
      if (parentNode && (this.isBTGDAndHDTV(parentNode.data) || this.isPBCNAndDVTT(parentNode.data))) {
        const uncheckedSiblingData = h.find(parentNode.childNodes, item => item.checked === false);
        if (!uncheckedSiblingData) {
          parentNode.checked = true;
        } else {
          parentNode.checked = false;
        }
      }
    },

    // Set checked cho children
    setCheckedForChildren(data, isChecked) {
      if (isChecked) {
        const node = this.$refs.tree.getNode(data);
        this.$set(node, 'expanded', isChecked)

        for (const children of data.children) {
          this.$refs.tree.setChecked(children, isChecked);
          this.handleCheckChange(children, isChecked)
        }
      } else {
        let isCheckedAllChildren = true;
        for (const children of data.children) {
          const childNode = this.$refs.tree.getNode(children);
          if (childNode.checked === false) {
            isCheckedAllChildren = false;
            break;
          }
        }
        if (isCheckedAllChildren) {
          for (const children of data.children) {
            this.$refs.tree.setChecked(children, isChecked);
          }
        }
      }
    },

    getNodeLabel(node) {
      return utils.getNodeLabelForHandlersTree(node);
    },

    isShowProcessTypeRadio(node) {
      return !this.isBTGDAndHDTV(node.data) && node.checked
    },

    isBTGDAndHDTV(data) {
      return data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.BTGD
        || data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.HDTV
        || (data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT && data.department.deptCode === constants.HDTV_DEPT_CODE)
    },

    isPBCNAndDVTT(data) {
      return data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.PBCN
        || data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DVTT
        || data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.PBCNAndDVTT
    },

    // remove ROOT node
    removeNodeROOT(root) {
      if (root.length > 0 && root[0].nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
        root[0].department.deptCode === constants.ROOT_DEPT_CODE) {
        const rootChildrenNode = root[0].children;
        const tctNode = rootChildrenNode.filter(item => item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT && item.department.deptCode === this.$store.getters.globalRoles)
        root = tctNode;
      }
      return root;
    },

    // chuyen userDeptRole trong TCT xuong cuoi tree
    moveUserOfTCTToBottom(root) {
      console.log('root', root)
      let childrenNodes = root[0].children;
      const userDeptRoleNodes = h.findAll(childrenNodes,
        item => item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE);

      for (const node of userDeptRoleNodes) {
        const index = childrenNodes.indexOf(node);
        if (index > -1) {
          childrenNodes.splice(index, 1); // 2nd parameter means remove one item only

          // Nếu là root là Đảng ủy TCT hoặc TCT thì bỏ các node con cá nhân trực tiếp
          if (![constants.DANG_UY_TCT_DEPT_CODE, this.$store.getters.globalRoles].includes(root[0].department.deptCode)) {
            childrenNodes.push(node);
          }
        }
      }
      // root[0].children = root[0].children.concat(userDeptRoleNodes)
      return root;
    },

    changeProcessType() {
      for (let i = 0; i < this.selectedHandlersData.length; i++) {
        const item = this.selectedHandlersData[i];
        if (item.data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE) {
          if(item.data.userDeptRole.id in this.processTypeRadio) {
            item.data.processType = this.processTypeRadio[item.data.userDeptRole.id]
            item.processType = this.processTypeRadio[item.data.userDeptRole.id]
          }
        } else {
          if(item.data.department.id in this.processTypeRadio) {
            item.data.processType = this.processTypeRadio[item.data.department.id]
            item.processType = this.processTypeRadio[item.data.department.id]
          }
        }
      }
    },

    addOrRemoveToSelectedHandlers(data, processType) {
      const node = this.$refs.tree.getNode(data);
      let checked = node.checked;
      let index = h.indexOf(this.selectedHandlersData, item => item.data === data);
      if (checked) {
        if (index === -1) {
          this.selectedHandlersData.push({
            data: data,
            processType: processType
          });
        }
      } else {
        const key = data.userDeptRole ? data.userDeptRole.id : data.department.id;
        this.$delete(this.processTypeRadio, key);
        this.selectedHandlersData.splice(index, 1);
      }
    },

    getSelectedHandlersData() {
      return this.selectedHandlersData;
    },

    findAllParentIdsOfNodeDatas(datas) {
      if (datas.length === 0) {
        return [];
      }
      let parentIds = [];
      const parentDatas = [];
      for (const data of datas) {
        if ('parent' in data && parentIds.indexOf(data.parent.id) !== 1) {
          parentDatas.push(data.parent)
          parentIds.push(data.parent.id)
        }
      }
      parentIds = parentIds.concat(this.findAllParentIdsOfNodeDatas(parentDatas))
      parentIds.filter((item,index)=>{
        return (parentIds.indexOf(item) == index)
      })
      return parentIds;
    },

    refreshNodeExpand() {
      const checkedDatas = this.$refs.tree.getCheckedNodes();
      const parentIds = this.findAllParentIdsOfNodeDatas(checkedDatas);

      for (const checkedData of checkedDatas) {
        if ('parent' in checkedData && parentIds.indexOf(checkedData.parent.id) !== -1) {
          parentIds.push(checkedData.parent.id)
        }
      }
      // const parentIds = h.collect(checkedDatas, item => item.parent ? item.parent.id)
      this.collapseAllNode(this.roots[0]);

      // expanded default
      const rootNode = this.$refs.tree.getNode(this.roots[0].id);
      if (rootNode) rootNode.expanded = true;
      const btgdNode = this.$refs.tree.getNode(constants.DEPARTMENT_TREE.NODE_TYPE.BTGD);
      if (btgdNode) btgdNode.expanded = true;

      for (const parentId of parentIds) {
        const node = this.$refs.tree.getNode(parentId);
        if (node) {
          node.expanded = true;
        }
      }
    },

    collapseAllNode(data) {
      h.each(data.children, child =>
        this.collapseAllNode(child)
      )
      const node = this.$refs.tree.getNode(data.id);
      if (node && node.data.nodeType === 'dept') {
        node.expanded = false;
      }
    },

    selectHashTag(event, hashtagProcessTypeSelect) {
      this.hashtagProcessTypeSelect = hashtagProcessTypeSelect;

      for (const item of event) {
        let node;
        if (item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.BTGD || item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.HDTV) {
          node = this.$refs.tree.getNode(item.nodeType);
        } else if (item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT) {
          node = this.$refs.tree.getNode(item.department.id);
        } else if (item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE) {
          node = this.$refs.tree.getNode(item.handler.id);
        }

        if (node) {
          this.$refs.tree.setChecked(node.data, true);
          this.handleCheckChange(node.data, true)
          this.refreshNodeExpand();
        }
      }

    },

    unSelectHashTag(event) {
      this.hashtagProcessTypeSelect = null;
      for (const item of event) {
        let node;
        if (item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.BTGD || item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.HDTV) {
          node = this.$refs.tree.getNode(item.nodeType);
        } else if (item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT) {
          node = this.$refs.tree.getNode(item.department.id);
        } else if (item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE) {
          node = this.$refs.tree.getNode(item.handler.id);
        }

        if (node) {
          this.$refs.tree.setChecked(node.data, false);
        }
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/doc-in/components/so-duyet-tree.vue